import { FiPlus, FiDownload } from "react-icons/fi";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetbillingoverviewQuery } from "../../State/Api/InvoiceApiSlice";

const PatientBilling = ({ patientUserUniqueID }) => {
  const navigate=useNavigate();
  const [fetchpatientbilling, { data: patientbillingData = {}, isFetching }] =
    useLazyGetbillingoverviewQuery();

  useEffect(() => {
    if (patientUserUniqueID) {
      fetchpatientbilling(patientUserUniqueID);
    }
  }, [patientUserUniqueID, fetchpatientbilling]);
  return (
    <div className="mt-2 space-y-4">
      {/* Header */}
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4">
          <div>
            <h2 className="text-xl xl:text-2xl font-semibold mb-2 tracking-tight">
              Billing History
            </h2>
            <div className="text-sm text-gray-500">
              View all billing and payment information.
            </div>
          </div>
          <div className="flex gap-2">
            {/* <button className="inline-flex items-center gap-2 rounded-md text-sm font-medium border px-4 py-2 hover:bg-gray-100">
              <FiDownload className="h-4 w-4" /> Export History
            </button> */}
            {/* <button onClick={()=>navigate("/CreateInvoice")} className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-[#171717] text-white hover:bg-[#2e2e2e] px-4 py-2 transition-colors gradient-button">
              <FiPlus className="h-4 w-4" /> New Invoice
            </button> */}
          </div>
        </div>

        {/* Static Table */}
        <div className="p-4">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th className="px-6 py-3">Date</th>
                  <th className="px-6 py-3">Type</th>
                  <th className="px-6 py-3 text-center">Amount</th>
                  <th className="px-6 py-3 text-center">Payment Type</th>

                  <th className="px-6 py-3">Status</th>
                  {/* <th className="px-6 py-3 text-right">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {patientbillingData.length > 0 ? (
                  patientbillingData.map((bill, index) => (
                    <tr
                      key={index}
                      className={
                        index % 2 === 0
                          ? "bg-white border-b"
                          : "bg-gray-50 border-b"
                      }
                    >
                      <td className="px-6 py-4 font-medium text-gray-900">
                        {bill?.invoiceDate
                          ? new Date(bill.invoiceDate)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/ /g, "-")
                          : "N/A"}
                      </td>
                      <td className="px-6 py-4">{bill.appointmentType}</td>
                      <td className="px-6 py-4 text-center">
                        ₹{bill.totalAmount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-center">
                        {bill?.paymentType}
                      </td>

                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${
                            bill.status === "Paid"
                              ? "bg-green-500 text-white"
                              : "bg-yellow-400 text-white"
                          }`}
                        >
                          {bill.status}
                        </span>
                      </td>
                      {/* <td className="px-6 py-4 text-right">
          <a href="#" className="text-blue-600 hover:underline font-medium">
            Edit
          </a>
        </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="px-6 py-4 text-center text-gray-500"
                    >
                      No billing records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Summary Cards */}
      {/* <div className="rounded-lg border bg-white shadow-sm">
        <div className="p-4">
          <h2 className="text-xl font-semibold mb-2 tracking-tight">
            Payment Summary
          </h2>
          <div className="text-sm text-gray-500 mb-4">
            Overview of patient’s payment history.
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="rounded-lg border p-4">
              <h3 className="text-base font-semibold mb-1">Total Billed</h3>
              <p className="text-2xl font-bold">₹1,130.00</p>
              <p className="text-sm text-gray-500">Year to date</p>
            </div>
            <div className="rounded-lg border p-4">
              <h3 className="text-base font-semibold mb-1">
                Insurance Covered
              </h3>
              <p className="text-2xl font-bold">₹904.00</p>
              <p className="text-sm text-gray-500">80% coverage</p>
            </div>
            <div className="rounded-lg border p-4">
              <h3 className="text-base font-semibold mb-1">Patient Paid</h3>
              <p className="text-2xl font-bold">₹152.00</p>
              <p className="text-sm text-red-500">₹74.00 outstanding</p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default PatientBilling;
